import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-next-button-atom',
  templateUrl: './next-button-atom.component.html',
})
export class NextButtonAtomComponent {
  @Output() buttonClick = new EventEmitter<Event>();
}
